import { useTheme } from "@emotion/react";
import { Alert, Box, useMediaQuery } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

const AnnounceAgeLimit = () => {
    const theme = useTheme();
    const isSp = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <Box
            sx={{
                maxWidth: "460px",
                margin: "4px auto auto",
            }}
        >
            <Alert severity="info" sx={{padding: "6px 10px", justifyContent: "center"}}>
                アカウント登録申請が承認されませんでした{!isSp && <br/>}（<Link to={"/agreement"}>利用規約</Link> 第３条４項）<br/>
            </Alert>
        </Box>
    );
};

export default AnnounceAgeLimit;
